import { IS_SSR, LocalStorageKeys, navigation } from '@/app'
import { AppStatus, Session } from '@/redux'
import { LocalStorage, toggleOnboardingQuestionsVisibility } from '@/utils'
import { TypeGuards } from '@codeleap/types'
import { analytics } from '../../analytics'
import { getFirebase } from '../../firebaseApp'
import { queryClient } from '../queryClient'
import { QueryKeys } from './queryKeys'

const clearStorageKeys = async () => {
  const storageKeys = LocalStorage.getAllKeys()

  if (TypeGuards.isArray(storageKeys)) {
    const keysToRemove = [
      LocalStorageKeys.PERSIST_AUTH,
      LocalStorageKeys.IN_REAUTHENTICATION,
      LocalStorageKeys.QUESTIONS_LAST_AUTO_OPENENED,
      LocalStorageKeys.HAS_SKIPPED_EMAIL_VERIFICATION,
      LocalStorageKeys.LESSON_STORE,
    ]

    const removedKeys = storageKeys?.filter((key) => {
      return key?.includes('learn') || keysToRemove.includes(key)
    })

    for (const key in removedKeys) {
      LocalStorage.removeItem(key)
    }
  }
}

export const logout = (withDone = true, isDelete = false) => {
  return new Promise<void>(async (resolve) => {
    if (withDone) {
      AppStatus.set('loading')
    }

    clearStorageKeys()

    const firebase = await getFirebase()

    if (withDone) {
      AppStatus.set('loading')
    }

    setTimeout(() => {
      firebase.auth().signOut()
      queryClient.client.clear()
      AppStatus.clearModals()

      if (!isDelete) {
        analytics.track('log_out')
      }

      const userData = QueryKeys.me.getData()

      analytics.identify({ user: userData, isLoggedIn: false })

      setTimeout(() => {
        if (withDone) {
          AppStatus.set('done')
        }

        setTimeout(() => {
          analytics.reset()
          navigation.navigate('Home')
          resolve()
        })
      }, 1000)
    }, 2000)

    Session.setHasLoggedOut(true)
    toggleOnboardingQuestionsVisibility()
  })
}
